import React, { memo } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import Journal from "pagesV2/pro/Calendar/Modals/Journal"
import styles from "./index.module.css"
import ReservationDetailModal from "pagesV2/pro/Bookings/ReservationDetailPage/ReservationDetailModal"
import { useDayCell } from "./hooks/useDayCell"

const DayCell = ({ day, monthStartDate, monthEndDate, onChangeFilters, timeOffRanges = [], allDayTimeOff = false, thisMonth = true, hideBookings = false }) => {
  const {
    content,
    isJournalModalOpen,
    isBookingModalOpen,
    selectedDate,
    selectedBookingId,
    handleCancel,
    handleBookingCancelSuccess,
    isPastDay,
    setJournalOpen
  } = useDayCell({ day, timeOffRanges, allDayTimeOff, onChangeFilters, hideBookings })

  const classes = ["d-flex flex-column"]

  return (
    <>
      <div
        className={
          `${classes.join(" ")} ${styles.showOnHover} ${styles.dayCellContainer} ` +
          (thisMonth ? "" : styles.notCurrentMonthDay + " ") +
          (allDayTimeOff ? styles.dayCellAllDay + " " : "")
        }
        aria-disabled={isPastDay}
      >
        {content}
      </div>
      {isJournalModalOpen && (
        <Journal
          open={isJournalModalOpen}
          setOpen={setJournalOpen}
          onCancel={handleCancel}
          selectedDate={selectedDate}
          startDate={monthStartDate}
          endDate={monthEndDate}
        />
      )}
      {isBookingModalOpen && (
        <ReservationDetailModal open={isBookingModalOpen} bookingUuid={selectedBookingId} onClose={handleBookingCancelSuccess} />
      )}
    </>
  )
}

DayCell.propTypes = {
  day: PropTypes.instanceOf(moment).isRequired,
  monthStartDate: PropTypes.instanceOf(moment),
  monthEndDate: PropTypes.instanceOf(moment),
  onChangeFilters: PropTypes.func.isRequired,
  timeOffRanges: PropTypes.arrayOf(PropTypes.string),
  allDayTimeOff: PropTypes.bool,
  thisMonth: PropTypes.bool,
  hideBookings: PropTypes.bool,
}

DayCell.defaultProps = {
  monthStartDate: moment(),
  monthEndDate: moment(),
  timeOffRanges: [],
  allDayTimeOff: false,
  thisMonth: true
}

export default memo(DayCell)
